/**
 * 🌐 HTTP Client - Cliente para comunicación con la API
 * @version 1.0.0
 * @description Cliente HTTP para manejar peticiones al servidor
 */

export class HTTPClient {
  constructor(baseUrl, config = {}) {
    this.baseUrl = baseUrl;
    this.config = {
      timeout: 10000,
      retries: 3,
      debug: false,
      ...config,
    };
    this.version = "1.0.0";
  }

  /**
   * 🔧 Realiza peticiones HTTP
   * @param {string} method - Método HTTP
   * @param {string} endpoint - Endpoint de la API
   * @param {Object} data - Datos a enviar
   * @param {string} apiKey - API key para autenticación
   * @returns {Promise<Object>} Respuesta de la API
   */
  async makeRequest(method, endpoint, data = null, apiKey = null) {
    const url = `${this.baseUrl}${endpoint}`;

    const options = {
      method,
      headers: {
        "Content-Type": "application/json",
        "X-SDK-Version": this.version,
      },
    };

    // Añadir API key en headers si está disponible
    if (apiKey) {
      options.headers["Authorization"] = `Bearer ${apiKey}`;
    }

    // Añadir body si hay data
    if (data) {
      options.body = JSON.stringify(data);
    }

    if (this.config.debug) {
      console.log("🌐 [HTTP Client] Realizando petición:", {
        method,
        url,
        options,
      });
    }

    try {
      const response = await fetch(url, options);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      if (error.name === "TypeError" && error.message.includes("fetch")) {
        throw new Error(
          "Error de conectividad. Verifica tu conexión a internet."
        );
      }
      throw error;
    }
  }

  /**
   * ⚙️ Actualiza la configuración del cliente
   * @param {Object} newConfig - Nueva configuración
   */
  updateConfig(newConfig) {
    this.config = { ...this.config, ...newConfig };
  }

  /**
   * 🔄 Actualiza la URL base
   * @param {string} newBaseUrl - Nueva URL base
   */
  updateBaseUrl(newBaseUrl) {
    this.baseUrl = newBaseUrl;
  }
}
